// @ngInject
function states($stateProvider, nsUtilProvider) {
  $stateProvider.state('profile-hub', {
    parent: 'root',
    url: '/manage',
    templateUrl: 'sections/profile-hub/templates/acp-profile-hub.ng.html',
    controller: function() {},
    data: {
      permissions: {
        only: 'hub_user',
        redirectTo: {
          hub_user: 'manage'
        }
      }
    },
    resolve: {
      pageTitle: /* @ngInject */ function(module, $injector) {
        return $injector.invoke(
          nsUtilProvider.getPageTitle('sections/profile-hub')
        );
      },
      module: /* @ngInject */ function($ocLazyLoad) {
        return import(/* webpackChunkName: "acp.section.profile-hub" */ 'sections/profile-hub').then(
          $ocLazyLoad.loadModule
        );
      }
    }
  });
}

export default states;
